import styled from '@emotion/styled';
import { FC } from 'react';
import { StyledInput } from '../styles';
import { FormInputProps } from '../utils';

type InputProps = {
  hasError?: boolean;
};

const Input = styled(StyledInput)<InputProps>`
  width: 100%;

  &.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: ${({ hasError }) =>
      hasError ? 'var(--color-i-red)' : 'var(--color-divider)'};
  }

  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ hasError }) =>
      hasError ? 'var(--color-i-red)' : 'var(--color-divider)'};
  }
`;

const TextInput: FC<FormInputProps> = ({
  value,
  onChange,
  hasError,
  placeholder = '',
  style = {}
}) => {
  return (
    <>
      <Input
        style={style}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        hasError={hasError}
      />
    </>
  );
};

export default TextInput;
